import { GPOVALLASAutoResolution } from './auto-resolution';
import { GPOVALLASAutoResolutionBranded } from './auto-resolution-branded';

export const GPOVALLAS_TEMPLATES = [GPOVALLASAutoResolution, GPOVALLASAutoResolutionBranded] as const;

export * from './auto-resolution';
export * from './auto-resolution-branded';
